// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-management-page {
  --subscription-bg: #171b23;
  --subscription-panel: #20252f;
  --subscription-panel-soft: #252c38;
  --subscription-border: rgba(255, 255, 255, 0.09);
  --subscription-text: #f4f7fb;
  --subscription-muted: rgba(244, 247, 251, 0.72);
  --subscription-accent: #58a6ff;
  --subscription-accent-soft: rgba(88, 166, 255, 0.16);
  --subscription-danger: #ff7b72;
}

.subscription-management-page .subscription-hero {
  overflow: hidden;
  background: var(--secondary-clr);
}

.subscription-management-page .subscription-hero::before {
  background: var(--secondary-clr);
}

.subscription-heading-copy {
  gap: 6px;
}

.subscription-hero-copy {
  max-width: 660px;
  margin: 0;
  font-size: 15px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.82);
}

.subscription-hero-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.subscription-hero-actions .outline-btn,
.subscription-hero-actions .primary-btn,
.subscription-editor-actions .outline-btn,
.subscription-delete-btn,
.subscription-footer .primary-btn {
  min-height: 46px;
}

.subscription-hero-actions .outline-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.subscription-hero-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 24px;
}

.subscription-stat-pill {
  min-width: 180px;
  padding: 14px 16px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
}

.subscription-stat-pill span {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.subscription-stat-pill small {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.72);
}

.subscription-stat-pill.is-alert {
  border-color: rgba(255, 208, 102, 0.35);
  background: rgba(255, 208, 102, 0.12);
}

.subscription-plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 18px;
}

.subscription-plan-card {
  min-height: 280px;
  padding: 22px;
  border-radius: 22px;
  border: 1px solid #343c49;
  background: var(--secondary-clr);
  color: var(--subscription-text);
  text-align: left;
  box-shadow: 0 16px 40px rgba(9, 15, 29, 0.18);
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.subscription-plan-card:hover {
  transform: translateY(-3px);
  border-color: rgba(88, 166, 255, 0.5);
  box-shadow: 0 22px 50px rgba(7, 11, 21, 0.28);
}

.subscription-plan-card.is-selected {
  border-color: #ff666e;
  border-width: 5px;
}

.subscription-plan-card.is-highlighted {
  background: var(--secondary-clr);
}

.subscription-plan-card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.subscription-plan-card-top h2 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
}

.subscription-plan-card-top p {
  margin: 6px 0 0;
  color: rgba(255, 255, 255, 0.76);
  font-size: 15px;
}

.subscription-plan-status {
  padding: 7px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.subscription-plan-status.is-active {
  color: #d7ffef;
  background: rgba(61, 229, 190, 0.16);
}

.subscription-plan-status.is-inactive {
  color: #ffe3dc;
  background: rgba(255, 123, 114, 0.16);
}

.subscription-plan-description {
  min-height: 52px;
  margin: 14px 0 16px;
  color: var(--subscription-muted);
  font-size: 14px;
  line-height: 1.6;
}

.subscription-platforms {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.platform-chip {
  padding: 6px 11px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #eff5ff;
  background: rgba(255, 255, 255, 0.12);
}

.subscription-feature-preview {
  display: grid;
  gap: 10px;
}

.subscription-feature-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.86);
}

.subscription-feature-row span {
  color: rgba(255, 255, 255, 0.72);
}

.subscription-feature-row strong {
  text-align: right;
  font-weight: 700;
  color: #fff;
}

.subscription-editor {
  padding: 26px;
  border-radius: 24px;
  border: 1px solid #2d3440;
  background: var(--secondary-clr);
  color: var(--subscription-text);
  box-shadow: 0 24px 60px rgba(9, 15, 29, 0.18);
}

.subscription-editor-header,
.subscription-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.subscription-editor-eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.56);
}

.subscription-editor-header h2 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
}

.subscription-editor-subcopy {
  max-width: 560px;
  margin: 8px 0 0;
  color: var(--subscription-muted);
  line-height: 1.7;
}

.subscription-editor-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.subscription-delete-btn {
  padding: 11px 20px;
  border: 1px solid rgba(255, 123, 114, 0.24);
  background: rgba(255, 123, 114, 0.12);
  color: #ffd6d0;
  font-size: 14px;
  font-weight: 600;
}

.subscription-editor-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-top: 24px;
}

.subscription-panel {
  padding: 22px;
  border-radius: 20px;
  border: 1px solid var(--subscription-border);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.03));
}

.subscription-panel-wide {
  grid-column: 1 / -1;
}

.subscription-panel-heading {
  margin-bottom: 18px;
}

.subscription-panel-heading h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.subscription-panel-heading p {
  margin: 6px 0 0;
  color: var(--subscription-muted);
  line-height: 1.6;
}

.subscription-management-page .subscription-label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.82);
}

.subscription-management-page .form-control,
.subscription-management-page textarea.form-control {
  min-height: 48px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(10, 14, 21, 0.42);
  color: #fff;
  box-shadow: none;
}

.subscription-management-page textarea.form-control {
  min-height: 110px;
  resize: vertical;
}

.subscription-management-page .form-control::placeholder,
.subscription-management-page textarea.form-control::placeholder {
  color: rgba(255, 255, 255, 0.38);
}

.subscription-management-page .form-control:focus,
.subscription-management-page textarea.form-control:focus {
  border-color: rgba(88, 166, 255, 0.72);
  background: rgba(10, 14, 21, 0.58);
  color: #fff;
  box-shadow: 0 0 0 4px rgba(88, 166, 255, 0.12);
}

.subscription-inline-toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 18px;
}

.subscription-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 16px;
  border: 1px solid var(--subscription-border);
  background: rgba(255, 255, 255, 0.04);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.84);
}

.subscription-toggle.compact {
  width: 100%;
  min-height: 48px;
  justify-content: center;
}

.subscription-toggle input {
  accent-color: var(--subscription-accent);
}

.subscription-platform-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 18px;
}

.subscription-platform-toggle {
  min-width: 84px;
  padding: 11px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.82);
  font-size: 14px;
  font-weight: 600;
}

.subscription-platform-toggle.is-active {
  border-color: rgba(88, 166, 255, 0.4);
  background: rgba(88, 166, 255, 0.14);
  color: #fff;
}

.subscription-feature-list {
  display: grid;
  gap: 14px;
}

.subscription-feature-editor {
  padding: 18px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  background: rgba(255, 255, 255, 0.03);
}

.subscription-feature-editor.is-disabled {
  opacity: 0.68;
}

.subscription-remove-feature,
.subscription-add-feature {
  padding: 0;
  margin-top: 14px;
  border: 0;
  background: transparent;
  color: #8dc3ff;
  font-size: 14px;
  font-weight: 600;
}

.subscription-add-feature {
  margin-top: 18px;
}

.subscription-footer {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  align-items: center;
}

.subscription-footer-note {
  display: grid;
  gap: 4px;
}

.subscription-footer-note strong {
  font-size: 15px;
  color: #fff;
}

.subscription-footer-note span {
  color: var(--subscription-muted);
  line-height: 1.6;
}


input.form-control.readonly, input.form-control.readonly:focus  {
  background: #433f5a;
  -webkit-user-select: none !important;
          user-select: none !important;
  color: #b8a4ff;
  box-shadow: none;
  outline: none;
}

.subscription-editor input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}
 

@media screen and (max-width: 992px) {
  .subscription-editor-grid {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 768px) {
  .subscription-hero-actions,
  .subscription-editor-actions,
  .subscription-editor-header,
  .subscription-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .subscription-editor,
  .subscription-plan-card {
    padding: 20px;
  }

  .subscription-editor-header h2,
  .subscription-plan-card-top h2 {
    font-size: 24px;
  }
}

@media screen and (max-width: 576px) {
  .subscription-plan-grid {
    grid-template-columns: 1fr;
  }

  .subscription-editor {
    padding: 18px;
    border-radius: 20px;
  }

  .subscription-panel {
    padding: 18px;
  }

  .subscription-inline-toggles {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SubscriptionManagement.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kCAAkC;EAClC,gDAAgD;EAChD,4BAA4B;EAC5B,+CAA+C;EAC/C,8BAA8B;EAC9B,oDAAoD;EACpD,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,6CAA6C;EAC7C,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,yFAAyF;AAC3F;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,sCAAsC;EACtC,kCAAkC;EAClC,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,qCAAqC;EACrC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,oCAA4B;UAA5B,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;IAIE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".subscription-management-page {\n  --subscription-bg: #171b23;\n  --subscription-panel: #20252f;\n  --subscription-panel-soft: #252c38;\n  --subscription-border: rgba(255, 255, 255, 0.09);\n  --subscription-text: #f4f7fb;\n  --subscription-muted: rgba(244, 247, 251, 0.72);\n  --subscription-accent: #58a6ff;\n  --subscription-accent-soft: rgba(88, 166, 255, 0.16);\n  --subscription-danger: #ff7b72;\n}\n\n.subscription-management-page .subscription-hero {\n  overflow: hidden;\n  background: var(--secondary-clr);\n}\n\n.subscription-management-page .subscription-hero::before {\n  background: var(--secondary-clr);\n}\n\n.subscription-heading-copy {\n  gap: 6px;\n}\n\n.subscription-hero-copy {\n  max-width: 660px;\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.subscription-hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.subscription-hero-actions .outline-btn,\n.subscription-hero-actions .primary-btn,\n.subscription-editor-actions .outline-btn,\n.subscription-delete-btn,\n.subscription-footer .primary-btn {\n  min-height: 46px;\n}\n\n.subscription-hero-actions .outline-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.subscription-hero-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  margin-top: 24px;\n}\n\n.subscription-stat-pill {\n  min-width: 180px;\n  padding: 14px 16px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(10px);\n}\n\n.subscription-stat-pill span {\n  display: block;\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.subscription-stat-pill small {\n  display: block;\n  margin-top: 4px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.subscription-stat-pill.is-alert {\n  border-color: rgba(255, 208, 102, 0.35);\n  background: rgba(255, 208, 102, 0.12);\n}\n\n.subscription-plan-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 18px;\n}\n\n.subscription-plan-card {\n  min-height: 280px;\n  padding: 22px;\n  border-radius: 22px;\n  border: 1px solid #343c49;\n  background: var(--secondary-clr);\n  color: var(--subscription-text);\n  text-align: left;\n  box-shadow: 0 16px 40px rgba(9, 15, 29, 0.18);\n  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.subscription-plan-card:hover {\n  transform: translateY(-3px);\n  border-color: rgba(88, 166, 255, 0.5);\n  box-shadow: 0 22px 50px rgba(7, 11, 21, 0.28);\n}\n\n.subscription-plan-card.is-selected {\n  border-color: #ff666e;\n  border-width: 5px;\n}\n\n.subscription-plan-card.is-highlighted {\n  background: var(--secondary-clr);\n}\n\n.subscription-plan-card-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.subscription-plan-card-top h2 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.subscription-plan-card-top p {\n  margin: 6px 0 0;\n  color: rgba(255, 255, 255, 0.76);\n  font-size: 15px;\n}\n\n.subscription-plan-status {\n  padding: 7px 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.subscription-plan-status.is-active {\n  color: #d7ffef;\n  background: rgba(61, 229, 190, 0.16);\n}\n\n.subscription-plan-status.is-inactive {\n  color: #ffe3dc;\n  background: rgba(255, 123, 114, 0.16);\n}\n\n.subscription-plan-description {\n  min-height: 52px;\n  margin: 14px 0 16px;\n  color: var(--subscription-muted);\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.subscription-platforms {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.platform-chip {\n  padding: 6px 11px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #eff5ff;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.subscription-feature-preview {\n  display: grid;\n  gap: 10px;\n}\n\n.subscription-feature-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.86);\n}\n\n.subscription-feature-row span {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.subscription-feature-row strong {\n  text-align: right;\n  font-weight: 700;\n  color: #fff;\n}\n\n.subscription-editor {\n  padding: 26px;\n  border-radius: 24px;\n  border: 1px solid #2d3440;\n  background: var(--secondary-clr);\n  color: var(--subscription-text);\n  box-shadow: 0 24px 60px rgba(9, 15, 29, 0.18);\n}\n\n.subscription-editor-header,\n.subscription-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.subscription-editor-eyebrow {\n  margin: 0 0 6px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.56);\n}\n\n.subscription-editor-header h2 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.subscription-editor-subcopy {\n  max-width: 560px;\n  margin: 8px 0 0;\n  color: var(--subscription-muted);\n  line-height: 1.7;\n}\n\n.subscription-editor-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.subscription-delete-btn {\n  padding: 11px 20px;\n  border: 1px solid rgba(255, 123, 114, 0.24);\n  background: rgba(255, 123, 114, 0.12);\n  color: #ffd6d0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.subscription-editor-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n  margin-top: 24px;\n}\n\n.subscription-panel {\n  padding: 22px;\n  border-radius: 20px;\n  border: 1px solid var(--subscription-border);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.03));\n}\n\n.subscription-panel-wide {\n  grid-column: 1 / -1;\n}\n\n.subscription-panel-heading {\n  margin-bottom: 18px;\n}\n\n.subscription-panel-heading h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.subscription-panel-heading p {\n  margin: 6px 0 0;\n  color: var(--subscription-muted);\n  line-height: 1.6;\n}\n\n.subscription-management-page .subscription-label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.subscription-management-page .form-control,\n.subscription-management-page textarea.form-control {\n  min-height: 48px;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(10, 14, 21, 0.42);\n  color: #fff;\n  box-shadow: none;\n}\n\n.subscription-management-page textarea.form-control {\n  min-height: 110px;\n  resize: vertical;\n}\n\n.subscription-management-page .form-control::placeholder,\n.subscription-management-page textarea.form-control::placeholder {\n  color: rgba(255, 255, 255, 0.38);\n}\n\n.subscription-management-page .form-control:focus,\n.subscription-management-page textarea.form-control:focus {\n  border-color: rgba(88, 166, 255, 0.72);\n  background: rgba(10, 14, 21, 0.58);\n  color: #fff;\n  box-shadow: 0 0 0 4px rgba(88, 166, 255, 0.12);\n}\n\n.subscription-inline-toggles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 18px;\n}\n\n.subscription-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 16px;\n  border: 1px solid var(--subscription-border);\n  background: rgba(255, 255, 255, 0.04);\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.84);\n}\n\n.subscription-toggle.compact {\n  width: 100%;\n  min-height: 48px;\n  justify-content: center;\n}\n\n.subscription-toggle input {\n  accent-color: var(--subscription-accent);\n}\n\n.subscription-platform-picker {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.subscription-platform-toggle {\n  min-width: 84px;\n  padding: 11px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.subscription-platform-toggle.is-active {\n  border-color: rgba(88, 166, 255, 0.4);\n  background: rgba(88, 166, 255, 0.14);\n  color: #fff;\n}\n\n.subscription-feature-list {\n  display: grid;\n  gap: 14px;\n}\n\n.subscription-feature-editor {\n  padding: 18px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.subscription-feature-editor.is-disabled {\n  opacity: 0.68;\n}\n\n.subscription-remove-feature,\n.subscription-add-feature {\n  padding: 0;\n  margin-top: 14px;\n  border: 0;\n  background: transparent;\n  color: #8dc3ff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.subscription-add-feature {\n  margin-top: 18px;\n}\n\n.subscription-footer {\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  align-items: center;\n}\n\n.subscription-footer-note {\n  display: grid;\n  gap: 4px;\n}\n\n.subscription-footer-note strong {\n  font-size: 15px;\n  color: #fff;\n}\n\n.subscription-footer-note span {\n  color: var(--subscription-muted);\n  line-height: 1.6;\n}\n\n\ninput.form-control.readonly, input.form-control.readonly:focus  {\n  background: #433f5a;\n  user-select: none !important;\n  color: #b8a4ff;\n  box-shadow: none;\n  outline: none;\n}\n\n.subscription-editor input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n  cursor: pointer;\n}\n \n\n@media screen and (max-width: 992px) {\n  .subscription-editor-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .subscription-hero-actions,\n  .subscription-editor-actions,\n  .subscription-editor-header,\n  .subscription-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .subscription-editor,\n  .subscription-plan-card {\n    padding: 20px;\n  }\n\n  .subscription-editor-header h2,\n  .subscription-plan-card-top h2 {\n    font-size: 24px;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .subscription-plan-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .subscription-editor {\n    padding: 18px;\n    border-radius: 20px;\n  }\n\n  .subscription-panel {\n    padding: 18px;\n  }\n\n  .subscription-inline-toggles {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
